"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = Portal;
exports["default"] = exports.mount = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mount = document.body;
exports.mount = mount;

function Portal(props) {
  var constnode = props.constnode,
      visible = props.visible,
      closeFuncCallback = props.closeFuncCallback,
      innerDomStyle = props.innerDomStyle,
      innerConstDomStyle = props.innerConstDomStyle,
      state = props.state,
      setState = props.setState,
      unmount = props.unmount,
      children = props.children,
      disabled = props.disabled;
  var render = (0, _react.useMemo)(function () {
    if (visible) {
      return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(state === true ? 'yhmodalopen' : 'yhmodalclose'),
        style: _objectSpread({}, innerDomStyle)
      }, children), mount);
    }

    unmount();
    return null;
  }, [innerDomStyle, children, state, unmount, visible]);
  (0, _react.useEffect)(function () {
    if (closeFuncCallback) {
      closeFuncCallback(setState);
    }
  }, [closeFuncCallback, setState]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, render, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread({
      display: 'inline-block'
    }, innerConstDomStyle),
    onClick: function onClick() {
      if (!disabled) {
        setState(!visible);
      }
    }
  }, constnode));
}

Portal.defaultProps = {
  disabled: false,
  closeFuncCallback: function closeFuncCallback() {},
  innerDomStyle: {},
  innerConstDomStyle: {}
};
Portal.propTypes = {
  visible: _propTypes["default"].bool.isRequired,
  constnode: _propTypes["default"].node.isRequired,
  closeFuncCallback: _propTypes["default"].func,
  innerDomStyle: _propTypes["default"].shape({}),
  innerConstDomStyle: _propTypes["default"].shape({}),
  setState: _propTypes["default"].func.isRequired,
  state: _propTypes["default"].bool.isRequired,
  unmount: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  disabled: _propTypes["default"].bool
};
var _default = Portal;
exports["default"] = _default;